import React, { memo } from "react";
import { TfiEmail } from "react-icons/tfi";
import { CgProfile } from "react-icons/cg";
import { VscDeviceMobile } from "react-icons/vsc";
import styles from "@components/Common/Profile.module.css";

/**
 * ProfileDetailItem component - Single profile detail row
 */
const ProfileDetailItem = memo(({ icon: Icon, label, value }) => (
  <div className={styles.profile__detailsBox}>
    <div className={styles.profile_label}>
      <Icon className={styles.profile__icon} /> {label}
    </div>
    <div className={styles.profile_entry}>{value}</div>
  </div>
));

ProfileDetailItem.displayName = "ProfileDetailItem";

/**
 * ProfileDetails component - Displays user information (mobile, email, profile type)
 */
const ProfileDetails = memo(({ mobileNumber, email, profileType }) => {
  return (
    <>
      <ProfileDetailItem
        icon={VscDeviceMobile}
        label="Mobile"
        value={mobileNumber}
      />
      <ProfileDetailItem
        icon={TfiEmail}
        label="Email ID"
        value={email}
      />
      <ProfileDetailItem
        icon={CgProfile}
        label="Profile Type"
        value={profileType}
      />
    </>
  );
});

ProfileDetails.displayName = "ProfileDetails";

export default ProfileDetails;
